import CRUD from '../masterData/genericCRUD'

const route = 'block_events'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function blockEvents(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {object} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		dispose: (body, config = {}) => {
			return instance.post('/disposals', body, config)
		},

		/**
		 * @param {object} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		addPlantsSourceFarm: (body, config = {}) => {
			return instance.post('/farm_transfers', body, config)
		},

		/**
		 * @param {object} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		addPlantsSourceNursery: (body, config = {}) => {
			return instance.post('/nursery_transfers', body, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		pruneDateCommentsUpdate: (id, body, config = {}) => {
			return instance.patch(`${route}/${id}`, body, config)
		}
	}
}
